import { RouteRecordRaw } from "vue-router";
import { addBreadCrumbs, BreadcrumbParam } from "@/core/layout";
import { addRoutes } from "@/core/router";

const settingsRoute: RouteRecordRaw = {
  path: "/settings",
  name: "settings",
  component: () => import("@/settings/pages/Settings.vue"),
  meta: {},
};

addRoutes([settingsRoute]);

const settingsBreadcrumb: BreadcrumbParam = {
  routeName: "settings",
  items: [
    {
      labelKey: "Auth.Home",
      route: "/dashboard",
      disabled: false,
      isTranslated: true,
      uniqueLabel: "",
    },
    {
      labelKey: "Settings",
      route: "/settings",
      disabled: true,
      isTranslated: true,
      uniqueLabel: "",
    },
  ],
};

addBreadCrumbs([settingsBreadcrumb]);
